import { sanitizeProductName } from './sanitizeProductName';
import { ProductNameProp } from './types';

export type GetUserGuideForProductProps = ProductNameProp;

/**
 * Gets the User Guide home page for the given product.
 * It detects whether the environment is cloud (TaaS) or on-prem.
 * Then the resulting URL is adjusted accordingly.
 */
export const getUserGuideForProduct = ({ productName }: GetUserGuideForProductProps) => {
  const sanitizedProductName = sanitizeProductName({ productName });
  const isTaas = !!window.head_conf?.console?.is_taas;
  const cloudOrOnPrem = isTaas ? 'cloud' : 'onprem';
  return `https://help.tanium.com/bundle/ug_${sanitizedProductName}_${cloudOrOnPrem}`;
};
